module.exports = __webpack_public_path__ + "static/img/iddis-details.0c98e9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/iddis-details.png
// module id = 3Kd6
// module chunks = 0